module.exports = __webpack_public_path__ + "static/media/LOGO-FFP-1.6be8b323.jpg";